import { useEffect, useRef, useState } from "react";

export function urlPolling(enabled: boolean, intervalMs = 1000) {
  const [url, setUrl] = useState(() => (typeof window !== "undefined" ? window.location.href : ""));
  const lastRef = useRef(url);
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (!enabled) return;

    const check = () => {
      const now = window.location.href;
      if (now !== lastRef.current) {
        lastRef.current = now;
        setUrl(now);
      }
    };

    const start = () => {
      if (timerRef.current == null) timerRef.current = window.setInterval(check, intervalMs);
    };
    const stop = () => {
      if (timerRef.current != null) {
        window.clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };

    if (!document.hidden) start();
    const onVisibility = () => {
      if (document.hidden) stop();
      else {
        check();
        start();
      }
    };
    document.addEventListener("visibilitychange", onVisibility);

    check();

    return () => {
      stop();
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [enabled, intervalMs]);

  return url;
}